/**
 * Accelera cart-status cookie
 *
 * Keeps a `shop_cart_count` cookie in sync with the Shopify cart so the
 * WordPress site (accelera.us) can show cart status and link back to
 * shop.accelera.us/cart and /checkout. The WordPress widget lives in the
 * accelera-store-ops repo.
 *
 * Cookie scope: when running on *.accelera.us the cookie is set on the
 * shared root domain (.accelera.us) so WordPress can read it. On any other
 * host (accelera-2.myshopify.com dev store, theme dev preview) it falls back
 * to a host-only cookie so the behavior is still testable before the
 * shop.accelera.us subdomain exists.
 *
 * Note: Safari caps JS-written cookie lifetime at 7 days regardless of
 * max-age; the cookie is refreshed on every page view and cart change,
 * so this only matters after 7+ days of no visits.
 */

(function () {
  var ROOT_DOMAIN = 'accelera.us';
  var COOKIE_NAME = 'shop_cart_count';
  var MAX_AGE_SECONDS = 1209600; // 14 days, matching Shopify cart persistence

  function writeCookie(count) {
    var cookie =
      COOKIE_NAME + '=' + encodeURIComponent(count) + '; path=/; max-age=' + MAX_AGE_SECONDS + '; SameSite=Lax; Secure';
    var host = window.location.hostname;
    if (host === ROOT_DOMAIN || host.endsWith('.' + ROOT_DOMAIN)) {
      cookie += '; domain=.' + ROOT_DOMAIN;
    }
    document.cookie = cookie;
  }

  function syncFromCart() {
    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js')
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        writeCookie(cart.item_count);
      })
      .catch(function () {
        /* network hiccup — keep the existing cookie value */
      });
  }

  // Initial sync on every page view (also corrects staleness after checkout,
  // since post-purchase pages can't run theme JS).
  syncFromCart();

  // Re-sync when the page is restored from the back/forward cache.
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) syncFromCart();
  });

  // Re-sync after any cart mutation, via Dawn's pub/sub (published by
  // product forms, cart page, cart drawer, and quick-add).
  // pubsub.js and constants.js load before this file in theme.liquid.
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      // Re-fetch /cart.js instead of trusting event payloads: add-to-cart
      // responses don't include a reliable item_count.
      syncFromCart();
    });
  }
})();
